export var AppleBusinessChatEvents;
(function (AppleBusinessChatEvents) {
    AppleBusinessChatEvents["CHANNEL_CONNECTION_APPLEBUSINESSCHAT_LINK"] = "channel-connection-applebusinesschat-link";
})(AppleBusinessChatEvents || (AppleBusinessChatEvents = {}));
